// This file should be used as the import source for native observers and their
// polyfills/ponyfills so it will be easier to swap out implementations if necessary.
export { default as IntersectionObserver } from './IntersectionObserver';
export { default as ResizeObserver } from 'resize-observer-polyfill';
